export default "assets/images/icons/slider-arrow-72440fc4.svg";